import React, { useEffect, useState } from "react";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router";
import MainLayout from "../../components/Common/MainLayout/MainLayout";
import { admin } from "../../utils/mainTabs/admin/admin";
import { tileSize } from "../../utils/tileSizes";
import { tileTypes } from "../../utils/tileTypes";
import { useDispatch } from "react-redux";
import { latestImportStatusActionHandler } from "../../store/actions/actionHandlers/adminActionHandler/organizationActionHandler";
import { colors } from "../../utils/stripeColors";
import { FaSyncAlt } from "react-icons/fa";

const AdminPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { tenantName } = useOutletContext();

  const [adminHeader, setAdminHeader] = useState("");
  const [adminNavLinks, setAdminNavLinks] = useState([]);
  const [adminButtons, setAdminButtons] = useState([]);
  const [adminTiles, setAdminTiles] = useState([]);
  const [adminTilesType, setAdminTilesType] = useState(tileTypes.SMALL);
  const [adminTilesSize, setAdminTilesSize] = useState(tileSize.SMALL);
  const [isAdminStepTiles, setIsAdminStepTiles] = useState(false);
  const [syncAzureDirectoryLoader, setSyncAzureDirectoryLoader] =
    useState(false);

  useEffect(() => {
    const { name: adminsName, tiles: adminsTiles, path: adminsPath } = admin;
    if (location.pathname === adminsPath(tenantName)) {
      const adminTiles = adminsTiles(navigate, tenantName);
      setAdminHeader(adminsName);
      setAdminNavLinks([]);
      setAdminButtons([]);
      setAdminTiles(adminTiles);
      setAdminTilesType(tileTypes.SMALL);
      setAdminTilesSize(tileSize.SMALL);
      setIsAdminStepTiles(false);
    } else {
      setAdminHeader("");
    }
  }, [location, navigate, tenantName]);

  const syncAzureDirectoryClick = () => {
    setSyncAzureDirectoryLoader(true);
    dispatch(latestImportStatusActionHandler(setSyncAzureDirectoryLoader));
  };
  return (
    <MainLayout
      heading={adminHeader}
      tiles={adminTiles}
      navLinks={adminNavLinks}
      tileType={adminTilesType}
      tileSize={adminTilesSize}
      isStepTile={isAdminStepTiles}
      buttons={adminButtons}
      isOrganiseSettingText={
        <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
          <b>Sync Azure Active Directory for Users</b>{" "}
          <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (!syncAzureDirectoryLoader) syncAzureDirectoryClick();
            }}
          >
            <FaSyncAlt
              color={syncAzureDirectoryLoader ? "gray" : colors.theme}
            />
          </span>
        </div>
      }
      syncAzureDirectoryClick={syncAzureDirectoryClick}
    >
      <Outlet
        context={{
          tenantName,
          setAdminHeader,
          setAdminNavLinks,
          setAdminButtons,
          setAdminTiles,
          setAdminTilesType,
          setAdminTilesSize,
          setIsAdminStepTiles,
        }}
      />
    </MainLayout>
  );
};

export default AdminPage;
